export const markAsUnread = "aSa";
export const markAsUnreadNumberOfConversationsWhenCountIsNegative = "bSa";
export const markAsUnreadNumberOfItemsWhenCountIsNegative = "cSa";
export const markAsUnreadNumberOfConversations = "dSa";
export const markAsUnreadNumberOfItems = "eSa";
export default {markAsUnread,markAsUnreadNumberOfConversationsWhenCountIsNegative,markAsUnreadNumberOfItemsWhenCountIsNegative,markAsUnreadNumberOfConversations,markAsUnreadNumberOfItems};